import React from "react";

const AddProductModal = ({
    show,
    newProductData,
    handleNewProductChange,
    handleMainImageChange,
    handleDetailImagesChange,
    saveNewProduct,
    closeAddProductModal,
    mainImageFile,
    detailImagesFiles,
    removeMainImage,
    removeDetailImage
}) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Add New Product</h3>

                {/* Name */}
                <div className="modal-field">
                    <label>Name*</label>
                    <input
                        type="text"
                        value={newProductData.name}
                        onChange={e => handleNewProductChange("name", e.target.value)}
                    />
                </div>

                {/* SKU */}
                <div className="modal-field">
                    <label>SKU*</label>
                    <input
                        type="text"
                        value={newProductData.sku}
                        onChange={e => handleNewProductChange("sku", e.target.value)}
                    />
                </div>

                {/* Description */}
                <div className="modal-field">
                    <label>Description*</label>
                    <textarea
                        rows="3"
                        value={newProductData.description}
                        onChange={e => handleNewProductChange("description", e.target.value)}
                    />
                </div>

                {/* Related Products */}
                <div className="modal-field">
                    <label>Related Products* (comma‑separated SKUs/IDs)</label>
                    <input
                        type="text"
                        placeholder="e.g. SKU123,SKU456"
                        value={newProductData.related_products}
                        onChange={e => handleNewProductChange("related_products", e.target.value)}
                    />
                </div>

                {/* Main Image with Preview */}
                <div className="modal-field">
                    <label>Main Image*</label>
                    {mainImageFile && (
                        <div
                            className="image-preview"
                            style={{
                                position: "relative",
                                display: "inline-block",
                                width: "150px",
                                height: "150px",
                                border: "1px solid #ccc",
                                marginBottom: "10px",
                                overflow: "hidden"
                            }}
                        >
                            <img
                                src={URL.createObjectURL(mainImageFile)}
                                alt="Main Preview"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover"
                                }}
                            />
                            {/* Cross button to remove main image */}
                            <button
                                className="delete-image-btn"
                                onClick={removeMainImage}
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    backgroundColor: "red",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "24px",
                                    height: "24px",
                                    cursor: "pointer",
                                    zIndex: 2
                                }}
                            >
                                X
                            </button>
                        </div>
                    )}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleMainImageChange}
                    />
                </div>

                {/* Detail Images with Preview */}
                <div className="modal-field">
                    <label>Detail Images* (one or more)</label>
                    <div className="detail-images-preview">
                        {detailImagesFiles &&
                            detailImagesFiles.map((file, index) => (
                                <div
                                    key={index}
                                    className="image-preview"
                                    style={{
                                        position: "relative",
                                        display: "inline-block",
                                        width: "150px",
                                        height: "150px",
                                        border: "1px solid #ccc",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        overflow: "hidden"
                                    }}
                                >
                                    <img
                                        src={URL.createObjectURL(file)}
                                        alt={`Detail Preview ${index}`}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }}
                                    />
                                    {/* Cross button to remove detail image */}
                                    <button
                                        className="delete-image-btn"
                                        onClick={() => removeDetailImage(index)}
                                        style={{
                                            position: "absolute",
                                            top: "5px",
                                            right: "5px",
                                            backgroundColor: "red",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "50%",
                                            width: "24px",
                                            height: "24px",
                                            cursor: "pointer",
                                            zIndex: 2
                                        }}
                                    >
                                        X
                                    </button>
                                </div>
                            ))}
                    </div>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleDetailImagesChange}
                    />
                </div>

                {/* Additional Info */}
                <div className="modal-field">
                    <label>Additional Info (optional)</label>
                    <textarea
                        rows="2"
                        value={newProductData.additional_info}
                        onChange={e => handleNewProductChange("additional_info", e.target.value)}
                    />
                </div>

                {/* Meta Title */}
                <div className="modal-field">
                    <label>Meta Title*</label>
                    <input
                        type="text"
                        value={newProductData.metaTitle}
                        onChange={e => handleNewProductChange("metaTitle", e.target.value)}
                    />
                </div>

                {/* Meta Description */}
                <div className="modal-field">
                    <label>Meta Description*</label>
                    <textarea
                        rows="3"
                        value={newProductData.metaDescription}
                        onChange={e => handleNewProductChange("metaDescription", e.target.value)}
                    />
                </div>

                {/* Meta Keywords */}
                <div className="modal-field">
                    <label>Meta Keywords* (comma‑separated)</label>
                    <input
                        type="text"
                        placeholder="e.g. keyword1, keyword2"
                        value={newProductData.metaKeywords}
                        onChange={e => handleNewProductChange("metaKeywords", e.target.value)}
                    />
                </div>

                {/* Actions */}
                <div className="modal-actions">
                    <button onClick={saveNewProduct}>Save</button>
                    <button onClick={closeAddProductModal}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default AddProductModal;
